__turbopack_context__.v({
  "background": "EventHero-module-scss-module__Qr-_Hq__background",
  "hero": "EventHero-module-scss-module__Qr-_Hq__hero",
  "root": "EventHero-module-scss-module__Qr-_Hq__root",
});
